/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_Existing_T1Inputs */

const en_plan_choose_existing_t1 = /** @type {(inputs: Plan_Choose_Existing_T1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy prompt`)
};

const id_plan_choose_existing_t1 = /** @type {(inputs: Plan_Choose_Existing_T1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin prompt`)
};

/**
* | output |
* | --- |
* | "Copy prompt" |
*
* @param {Plan_Choose_Existing_T1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_existing_t1 = /** @type {((inputs?: Plan_Choose_Existing_T1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_Existing_T1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_existing_t1(inputs)
	return en_plan_choose_existing_t1(inputs)
});